import React from 'react';
import YoutubePlayer from '../../../elements/components/YoutubePlayer';
import VimeoPlayer from '../../../elements/components/VimeoPlayer';

import useFetchSignedUrl from '../../../hooks/useFetchSignedUrl';
import imageLoading from './../../../assets/images/image-loading.png';

const ComponentMedia = ({
  data,
  imageUrl,
  image,
  imagePath,
  getSignedUrl,
  setActiveImage,
  ...props
}) => {
  const { video_youtube_url, video_vimeo_url } = data;

  useFetchSignedUrl(imagePath, imageUrl, getSignedUrl, setActiveImage);

  if (image) {
    return (
      <div style={{ marginBottom: '20px' }}>
        <img
          className='learning-admin-module-image'
          alt='media-module'
          src={imageUrl ?? imageLoading}
        />
      </div>
    );
  }

  if (video_youtube_url) {
    return (
      <div style={{ marginBottom: '20px' }}>
        <YoutubePlayer videoURL={video_youtube_url} />
      </div>
    );
  }

  if (video_vimeo_url) {
    return (
      <div style={{ marginBottom: '20px' }}>
        <VimeoPlayer vimeoURL={video_vimeo_url} />
      </div>
    );
  }

  return <></>;
};

export default ComponentMedia;
